import { useState } from "react";
import supabase from '../../services/supabase';

const AddPlace = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [enteredPassword, setEnteredPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [targetTable, setTargetTable] = useState("places");

  const correctPassword = process.env.REACT_APP_APPW; //this is our password

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (enteredPassword === correctPassword) {
      setAuthenticated(true);
    } else {
      alert("Incorrect password");
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    category: "",
    lat: "",
    lng: "",
    description: "",
    tags: [],
    address: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTagToggle = (tag) => {
    setFormData((prev) => {
      const tags = prev.tags.includes(tag)
        ? prev.tags.filter((t) => t !== tag)
        : [...prev.tags, tag];
      return { ...prev, tags };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Uploading...");

    const { error } = await supabase.from(targetTable).insert([
      {
        name: formData.name,
        category: formData.category,
        lat: parseFloat(formData.lat),
        lng: parseFloat(formData.lng),
        description: formData.description,
        tags: formData.tags,
        address: formData.address,
      },
    ]);

    if (error) {
      console.error(error);
      setStatus("❌ Failed to upload.");
    } else {
      setStatus("✅ Place uploaded successfully!");
      setFormData({
        name: "",
        category: "",
        lat: "",
        lng: "",
        description: "",
        tags: [],
        address: "",
      });
    }
  };

  // password mechanism
  if (!authenticated) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>Enter Password to Access This Page</h2>
        <form onSubmit={handlePasswordSubmit} style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
          <input
            type={showPassword ? "text" : "password"}
            value={enteredPassword}
            onChange={(e) => setEnteredPassword(e.target.value)}
            placeholder="Password"
            style={{ padding: "0.5rem" }}
          />
          <button type="button" onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? "Hide" : "Show"}
          </button>
          <button type="submit">Enter</button>
        </form>
      </div>
    );
  }


  
  // addplace form
  return (
    <div style={{ maxWidth: "500px", margin: "2rem auto", padding: "1rem" }}>
      <h2>Add a New Place</h2>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <label>
          Target Table:
          <select value={targetTable} onChange={(e) => setTargetTable(e.target.value)}>
            <option value="places">Davis (places)</option>
            <option value="bay_places">Bay Area (bay_places)</option>

            <option value="yolo_places">Yolo County (yolo_places)</option>
          </select>
        </label>
        <input
          type="text"
          name="name"
          placeholder="Place Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="category"
          placeholder="Category (e.g. Bars, Food, Entertainment, Hidden Gems)"
          value={formData.category}
          onChange={handleChange}
          required
        />
        <input
          type="number"
          name="lat"
          placeholder="Latitude"
          step="any"
          value={formData.lat}
          onChange={handleChange}
          required
        />
        <input
          type="number"
          name="lng"
          placeholder="Longitude"
          step="any"
          value={formData.lng}
          onChange={handleChange}
          required
        />
        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
          rows={3}
        />
        <input
          type="text"
          name="address"
          placeholder="Google maps URL"
          value={formData.address}
          onChange={handleChange}
          required
        />

        <div>
          <label>Select Tags:</label>
          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            {["car", "bike", "walking"].map((tag) => (
              <label key={tag}>
                <input
                  type="checkbox"
                  checked={formData.tags.includes(tag)}
                  onChange={() => handleTagToggle(tag)}
                />
                {" "}{tag}
              </label>
            ))}
          </div>
        </div>

        <button type="submit">Upload Place</button>
        <div>{status}</div>
      </form>
    </div>
  );
};

export default AddPlace;